export default __webpack_public_path__ + "09.01.2017_Pressemitteilung_LifeTime_Zwischenfinanzierung_Thieme9b86ada2e929327c58f1673855baba51.pdf";